import { ChartType } from '@dbl/core/chart';

import type {
  IAnalysisBarPercentageMinMaxItemDto,
  IAnalysisBarPercentageMinMaxItemVo,
  IAnalysisTableChartResponseDto,
  IAnalysisTableChartResultVo,
} from '../types';

import {
  isRecord,
  normalizeColumnHeaderList,
  normalizeStringArray,
  normalizeTableDataList,
} from './common';

function normalizeBarPercentageMinMaxItem(
  item: IAnalysisBarPercentageMinMaxItemDto | null | undefined,
): IAnalysisBarPercentageMinMaxItemVo | undefined {
  if (!isRecord(item)) {
    return undefined;
  }

  const { metric, table_code: tableCode, min, max } = item;

  if (typeof metric !== 'string') {
    return undefined;
  }

  return {
    metric,
    tableCode: typeof tableCode === 'string' ? tableCode : '',
    min: typeof min === 'number' ? min : Number(min) || 0,
    max: typeof max === 'number' ? max : Number(max) || 0,
  };
}

function normalizeBarPercentageMinMaxList(
  value: IAnalysisBarPercentageMinMaxItemDto[] | null | undefined,
): IAnalysisBarPercentageMinMaxItemVo[] {
  if (!Array.isArray(value)) {
    return [];
  }

  return value
    .map(normalizeBarPercentageMinMaxItem)
    .filter(
      (item): item is IAnalysisBarPercentageMinMaxItemVo => item !== undefined,
    );
}

export function transformTableChartResponseDtoToVo(
  dto: IAnalysisTableChartResponseDto,
): IAnalysisTableChartResultVo {
  const {
    metrics,
    column_name: columnNameWire,
    count,
    actual_count: actualCountWire,
    table_data: tableDataWire,
    crosstab_columns: crosstabColumns,
    bar_percentage_min_max: barPercentageMinMax,
  } = dto;

  return {
    chartType: ChartType.Table,
    columnName: normalizeColumnHeaderList(columnNameWire),
    count: typeof count === 'number' ? count : 0,
    actualCount: typeof actualCountWire === 'number' ? actualCountWire : 0,
    tableData: normalizeTableDataList(tableDataWire),
    crosstabColumns,
    barPercentageMinMax: normalizeBarPercentageMinMaxList(barPercentageMinMax),
    metrics: normalizeStringArray(metrics),
  };
}
